<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>

<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="row">
            <div class="col-md-12">
                <div mat-dialog-title>
                    <mat-icon class="nav-icon">monetization_on</mat-icon>Please provide the reason.
                </div>
            </div>
        </div>

        <div class="mat-dialog-content">
            <form [formGroup]="cancelPaymentForm" (ngSubmit)="onSubmit()">
                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Reason</mat-label>
                        <mat-select matInput type="text" formControlName="reasonCode"
                            [ngClass]="{'is-invalid':submitted && forms.reasonCode.errors}" required>
                            <mat-option *ngFor="let reason of reason"
                                [value]="reason.reasonCode" >{{reason.reasonCode}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="submitted && forms.reasonCode.errors" class="invalid-feedback">
                            <div *ngIf="forms.reasonCode.errors.required"> This field is required </div>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Comment</mat-label>
                        <input matInput formControlName="comment">
                    </mat-form-field>
                </div>
                <div class="buttonRow">
                    <button type="submit" mat-raised-button 
                        class="create">Cancel Payment</button>
                    <button type="reset" mat-raised-button (click)="onNoClick()" class="cancel">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>